<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="不动产业务类型" prop="orderType">
                <Select v-model="query.orderType" clearable>
                  <Option
                    v-for="item in typeList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="不动产业务单号" prop="orderNO">
                <Input
                  v-model="query.orderNO"
                  clearable
                  placeholder="请输入不动产业务单号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="不动产单元号" prop="estateUnitNO">
                <Input
                  v-model="query.estateUnitNO"
                  clearable
                  placeholder="请输入不动产单元号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="银行名称" prop="bankName">
                <Input
                  v-model="query.bankName"
                  clearable
                  placeholder="请输入银行名称"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="银行经理" prop="userName">
                <Input
                  v-model="query.userName"
                  clearable
                  placeholder="请输入银行经理"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="商户单号" prop="payOrderNo">
                <Input
                  v-model="query.payOrderNo"
                  clearable
                  placeholder="请输入商户单号"
                />
              </form-item>
            </i-col>
            <i-col span="6">
              <form-item label="缴纳金额" prop="payAmount">
                <Input
                  v-model="query.payAmount"
                  clearable
                  placeholder="请输入缴纳金额"
                />
              </form-item>
            </i-col>
            <!-- <i-col span="6">
              <form-item label="义务人" prop="obligor">
                <Input
                  v-model="query.obligor"
                  clearable
                  placeholder="请输入义务人"
                />
              </form-item>
            </i-col> -->
            <i-col span="6">
              <form-item label="支付时间" prop="eventtime">
                <DatePicker
                  v-model="time"
                  class="time"
                  type="daterange"
                  placeholder="请选择支付时间"
                ></DatePicker>
              </form-item>
            </i-col>

            <i-col span="6">
              <form-item label="是否开票" prop="status">
                <Select v-model="query.state" clearable>
                  <Option
                    v-for="item in invoiceList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <i-col
              span="6"
              v-if="this.$store.state.streetorcommunityid == 410927000000"
            >
              <form-item label="汇缴状态" prop="remitState">
                <Select v-model="query.remitState" clearable>
                  <Option
                    v-for="item in typeLists"
                    :key="item.index"
                    :value="item.index"
                    :label="item.type"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
            <Button
              v-if="this.$store.state.streetorcommunityid == 410927000000"
              type="primary"
              @click="
                () => {
                  modal = true;
                  alltotalAmountShou = false;
                }
              "
              style="margin: 35px"
              >汇缴</Button
            >
          </row>
        </i-form>
      </div>
      <div class="table-data">
        <i-table
          :columns="tableHeader"
          :border="true"
          :loading="isLoading"
          :data="tableData"
          stripe
          ref="table"
          @on-row-dblclick="handleClickDetail1"
          @on-selection-change="handleSelect"
        >
          <template slot-scope="{ row, index }" slot="action">
            <span @click.stop="handleClickDetail(row, 'detail')" class="action"
              >[详情]</span
            >
            <span
              v-if="
                $store.state.streetorcommunityid == '410927000000' &&
                row.state == '已冲红'
              "
              @click.stop="handleClickDetail(row, 'fee')"
              class="action"
              >[重新开票]</span
            >
            <span
              v-if="
                $store.state.streetorcommunityid == '410927000000' &&
                row.orderType != 1 &&
                row.orderType != 3 &&
                row.state != '已冲红'
              "
              @click.stop="handleClickDetail(row, 'gored')"
              class="action"
              >[冲红]</span
            >
            <span
              v-if="
                row.orderType != 1 &&
                row.orderType != 3 &&
                row.state != '已开票' &&
                row.state != '已冲红'
              "
              @click.stop="handleClickDetail(row, 'fee')"
              class="action"
              >[开票]</span
            >
            <span
              v-if="
                row.orderType != 1 &&
                row.orderType != 3 &&
                $store.state.streetorcommunityid != '410927000000'
              "
              @click.stop="handleClickDetail(row, 'gored')"
              class="action"
              >[冲红]</span
            >
            <span
              v-if="row.innerPdfAddr"
              @click.stop="handleClickDetail(row, 'preview')"
              class="action"
              >[预览下载]</span
            >
          </template>
        </i-table>
        <div class="statistics">
          总金额：{{ totalAmount }}元，已开票：{{
            invoiceAmount
          }}元，未开票金额：{{ amount }}元
        </div>
        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            @on-change="pageChange"
            show-total
          />
        </div>
      </div>
    </div>
    <Modal v-model="modal" title="电子汇缴" :mask-closable="false">
      <Form :model="formItem" :label-width="120">
        <FormItem label="缴款书号码">
          <Input v-model="PayVoucherNo" placeholder="请填写缴款书号码"></Input>
        </FormItem>
        <FormItem label="缴款书批次编码">
          <Input
            v-model="PayVoucherBTCode"
            placeholder="请填写缴款书批次编码"
          ></Input>
        </FormItem>
        <FormItem label="选择时间">
          <DatePicker
            type="daterange"
            format="yyyy-MM-dd"
            placeholder="请选择时间"
            @on-change="deteChange"
            style="width: 300px"
          />
        </FormItem>
      </Form>
      <p v-if="alltotalAmountShou">汇缴金额：{{ alltotalAmount }}</p>
      <div slot="footer">
        <Button type="info" @click="modal = false">取消</Button>
        <Button type="success" @click="ok">确定</Button>
      </div>
    </Modal>
    <Modal
      title="确认是否开票"
      v-model="showModal"
      @on-cancel="cancelModal"
      @on-ok="showModalConfirm"
      :loading="isLoading"
    >
      <div class="box">
        <div class="label">业务类型：</div>
        <div>{{ info.orderTypeName }}</div>
      </div>
      <div class="box">
        <div class="label">不动产单元号：</div>
        <div>{{ info.estateUnitNO }}</div>
      </div>
      <div class="box">
        <div class="label">房屋坐落：</div>
        <div>{{ info.address }}</div>
      </div>
      <div class="box">
        <div class="label">银行名称：</div>
        <div>{{ info.bankName }}</div>
      </div>
      <div class="box">
        <div class="label">银行经理：</div>
        <div>{{ info.userName }}</div>
      </div>
    </Modal>
    <Modal
      title="确认是否开票"
      v-model="showModal1"
      @on-cancel="cancelModal"
      @on-ok="showModalConfirm1"
      :loading="isLoading"
    >
      <div>确定要将这些登记信息（共{{ selectedList.length }}个）开票吗</div>
    </Modal>
    <Modal v-model="modal3" title="冲红" height="500" draggable>
      <i-form ref="search" :model="formItems" style="height: 200px">
        <i-col span="24">
          <form-item prop="redreason">
            <Input
              v-model="formItems.redreason"
              clearable
              placeholder="请输入冲红原因"
            />
          </form-item>
        </i-col>
        <!-- </row> -->
      </i-form>
      <div slot="footer">
        <Button type="info" @click="cancelgored">取消</Button>
        <Button type="success" @click="dogored">确定</Button>
      </div>
    </Modal>
    <preview-img
      :currentIndex="0"
      :imgArr="showPreview.list"
      v-if="showPreview.show"
      v-on:closePreview="closePreview"
    >
    </preview-img>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
import PreviewImg from "../../../components/previewImg";
import miment from "miment";
import { number } from "@amcharts/amcharts4/core";

const {
  taxInfoList,
  updateInvoice,
  updateInvoiceList,
  regfeeExport,
  invoice,
  saveHui,
  cancellation,
  getuser3list,
} = api;
const INVOICEMAP = {
  0: {
    state: "已冲红",
  },
  1: {
    state: "已开票",
  },
  2: {
    state: "未开票",
  },
  3: {
    state: "开票失败",
  },
};
const remitState = {
  0: {
    remitState: "未汇缴",
  },
  1: {
    remitState: "已汇缴",
  },
};
const TYPEMAP = {
  0: {
    type: "",
  },
  1: {
    type: "预告登记",
  },
  //   2: {
  //     type: "预告登记注销"
  //   },
  3: {
    type: "预抵押登记",
  },
  //   4: {
  //     type: "预抵押登记注销"
  //   },
  5: {
    type: "现房抵押",
  },
  //   6: {
  //     type: "现房抵押登记注销"
  //   },
  7: {
    type: "二手房登记",
  },
  15: {
    type: "房屋拆分",
  },
  9: {
    type: "新房办证",
  },
};
export default {
  name: "regfee",
  components: {
    pageHead,
    PreviewImg,
  },

  data() {
    return {
      alltotalAmount: "",
      alltotalAmountShou: false,
      PayVoucherNo: "",
      PayVoucherBTCode: "",
      formItems: {
        redreason: "",
      },
      modal: false,
      modal3: false,
      showPreview: {
        show: 0,
        list: [],
      },
      showModal: false,
      showModal1: false,
      invoiceList: [
        {
          index: 0,
          type: "已冲红",
        },
        {
          index: 1,
          type: "已开票",
        },
        {
          index: 2,
          type: "未开票",
        },
        {
          index: 3,
          type: "开票失败",
        },
      ],
      typeList: [
        {
          index: 0,
          type: "全部",
        },
        {
          index: 1,
          type: "预告登记",
        },
        // {
        //   index: 2,
        //   type: "预告登记注销"
        // },
        {
          index: 3,
          type: "预抵押登记",
        },
        // {
        //   index: 4,
        //   type: "预抵押登记注销"
        // },
        {
          index: 5,
          type: "现房抵押",
        },
        // {
        //   index: 6,
        //   type: "现房抵押登记注销"
        // },
        {
          index: 7,
          type: "二手房登记",
        },
        {
          index: 9,
          type: "新房办证",
        },
        {
          index: 15,
          type: "房屋拆分",
        },
        {
          index: 16,
          type: "换证",
        },
        {
          index: 99,
          type: "新房办证期转现",
        },
      ],
      typeLists: [
        {
          index: 0,
          type: "未汇缴",
        },
        {
          index: 1,
          type: "已汇缴",
        },
      ],
      query: {
        orderNO: "",
        estateUnitNO: "",
        bankName: "",
        userName: "",
        createTime: "",
        updateTime: "",
        orderType: "",
        state: "",
        obligor: "",
        apptype: "pc",
        payOrderNo: "",
        payAmount: "",
        remitState: "",
      },
      info: {},
      time: [miment().add(-1, "DD"), miment()],
      isLoading: false,
      invoiceAmount: 0,
      amount: 0,
      totalAmount: 0,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      title: "抵押登记费用",
      btnList: [
        {
          name: "重置",
          type: "reset",
        },
        {
          name: "搜索",
          type: "search",
        },
        // {
        //   name: "开票",
        //   type: "invoice",
        // },
        {
          name: "导出",
          type: "export",
        },
      ],
      tableHeader: [
        {
          type: "selection",
          width: 70,
          align: "center",
        },
        {
          title: "序号",
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "不动产业务类型",
          key: "orderTypeName",
          width: 140,
        },
        {
          title: "不动产业务单号",
          key: "orderNO",
          width: 140,
        },
        {
          title: "不动产单元号",
          key: "estateUnitNO",
        },
        {
          title: "银行名称",
          key: "bankName",
        },
        {
          title: "银行经理/权利人",
          key: "userName",
          width: 100,
        },
        {
          title: "义务人",
          key: "obligor",
          width: 80,
        },
        {
          title: "登记费缴纳订单号",
          key: "payOrderNo",
          width: 100,
        },
        {
          title: "支付时间",
          key: "updateTime",
          width: 180,
        },
        {
          title: "缴纳金额",
          key: "newpayAmount",
          width: 100,
        },
        {
          title: "是否开票",
          key: "state",
          width: 100,
        },
        {
          title: "电子票号",
          key: "einvoiceNumber",
          width: 100,
        },
        {
          title: "操作",
          slot: "action",
          width: 140,
        },
      ],
      tableData: [],
      selectedList: [],
      header: {
        token: window.sessionStorage.getItem("token"),
      },
    };
  },
  methods: {
    deteChange(e) {
      this.begincreatetime = e[0];
      this.endcreatetime = e[1];
      console.log(this.begincreatetime);
      console.log(this.endcreatetime);
    },
    async ok() {
      let data = {
        PayVoucherNo: this.PayVoucherNo,
        PayVoucherBTCode: this.PayVoucherBTCode,
        begincreatetime: this.begincreatetime + " 23:59:59",
        endcreatetime: this.endcreatetime + " 23:59:59",
        pageCount: 500,
        soureType: "web",
      };
      let res = await this.$post(saveHui, data);
      if (res.isSucceed) {
        if (res.message) {
          this.$Message.success(res.message);
        } else {
          this.$Message.success("汇缴成功");
        }
        this.alltotalAmount = res.newPrimaryKeys.alltotalAmount;
        this.alltotalAmountShou = true;
      } else {
        if (res.message) {
          this.$Message.success(res.message);
        } else {
          this.$Message.success("汇缴成败");
        }
      }
    },
    handleBtn(type) {
      if (type == "reset") {
        this.time = "";
        this.pageNum = 1;
        this.query.createTime = "";
        this.query.updateTime = "";
        this.query.state = "";
        this.query.estateUnitNO = "";
        this.query.obligor = "";
        this.query.orderNO = "";
        this.query.orderType = "";
        this.query.remitState = "";
        this.query.bankName = "";
        this.query.userName = "";
        this.query.payOrderNo = "";
        this.query.payAmount = "";
        this.$refs.search.resetFields();
        this.getTaxInfoList();
      } else if (type == "search") {
        this.pageNum = 1;
        this.getTaxInfoList();
      } else if (type == "invoice") {
        console.log("invoice");
        if (this.selectedList.length == 0) {
          return this.$Message.warning("请选择要开票的项目");
        }
        this.showModal1 = true;
      } else if (type == "export") {
        let {
          orderType,
          orderNO,
          estateUnitNO,
          bankName,
          userName,
          obligor,
          createTime,
          updateTime,
          state,
          apptype,
        } = this.query;
        let url =
          regfeeExport +
          "?orderType=" +
          orderType +
          "&orderNO=" +
          orderNO +
          "&estateUnitNO=" +
          estateUnitNO +
          "&bankName=" +
          bankName +
          "&userName=" +
          userName +
          "&obligor=" +
          obligor +
          "&createTime=" +
          createTime +
          "&updateTime=" +
          updateTime +
          "&state=" +
          state +
          "&apptype=" +
          apptype +
          "&token=" +
          this.header.token +
          "&communityId=" +
          this.$store.state.streetorcommunityid;

        console.log(url);
        window.open(url);
      }
    },
    async showModalConfirm() {
      this.isLoading = true;
      try {
        let data = {};
        let itemCode = "";
        let itemName = "";
        let auxItemRelatedCode = "";
        let auxItemRelatedName = "";
        let itemStd = "";
        let itemQuantity = 1;
        if (
          window.location.host.indexOf("ceshi.shequyun.cn") >= 0 ||
          window.location.host.indexOf("localhost") >= 0
        ) {
          itemCode = "900007";
          itemName = "卸车费";
          auxItemRelatedCode = "001";
          auxItemRelatedName = "卸车费";
          itemStd = Number(this.info.payAmount) / 100;
          itemQuantity = 1;
        } else if (window.location.host.indexOf("py.shequyun.cn") >= 0) {
          if (this.info.payAmount == 55000) {
            itemCode = 692001;
            itemName = "不动产登记费";
            auxItemRelatedCode = "003";
            auxItemRelatedName = "非住宅类不动产登记费";
            itemStd = Number(this.info.payAmount) / 100;
            itemQuantity = 1;
          } else if (this.info.payAmount == 8000) {
            itemCode = 692001;
            itemName = "不动产登记费";
            auxItemRelatedCode = "001";
            auxItemRelatedName = "住宅类不动产登记费";
            itemStd = Number(this.info.payAmount) / 100;
            itemQuantity = 1;
          } else if (this.info.payAmount == 1000) {
            itemCode = 692002;
            itemName = "证书工本费";
            auxItemRelatedCode = "001";
            auxItemRelatedName = "证书工本费（一个以上）";
            itemStd = 10;
            itemQuantity = 1;
          } else {
            if (this.info.orderTypeName == "房屋拆分") {
              itemCode = 692002;
              itemName = "证书工本费";
              auxItemRelatedCode = "001";
              auxItemRelatedName = "证书工本费（一个以上）";
              itemStd = 10;
              itemQuantity = Number(this.info.payAmount) / 1000;
            }
          }
        }
        if (
          this.info.orderTypeName == "新房办证" ||
          this.info.orderTypeName == "二手房转移"
        ) {
          let payerPartyName = "";
          let payerPartyCode = "";
          let phone = "";
          let payerPartyType = 1;
          let newres = await this.$get(getuser3list, {
            orderNO: this.info.orderNO,
          });
          console.log(newres);
          if (newres.isSucceed) {
            if (newres.rows && newres.rows.length > 0) {
              let userlist = newres.rows[0];
              if (userlist && userlist.length > 0) {
                for (let i = 0; i < userlist.length; i++) {
                  if (userlist[i].userType == 1) {
                    payerPartyName = userlist[i].userName;
                    payerPartyCode = userlist[i].idCardNO;
                    phone = userlist[i].phoneNO;
                    break;
                  }
                }
              }
              console.log(this.$store.state.streetorcommunityid);
              if (this.$store.state.streetorcommunityid == 410927000000) {
                data = {
                  soureType: "web",
                  estateUnitNO: this.info.estateUnitNO,
                  reason: "",
                  orderNo: this.info.orderNO,
                  payOrderNO: this.info.payOrderNo,
                  PayerPartyName: payerPartyName,
                  PlaceCode: "",
                  TotalAmount: Number(this.info.payAmount) / 100,
                  PayerPartyCode: payerPartyCode,
                  Remark: "",
                  PayerPartyType: 1,
                  Details: [
                    {
                      ItemCode: itemCode,
                      ItemRemark: "",
                      ItemQuantity: itemQuantity,
                      ItemName: itemName,
                      ItemStd: itemStd,
                      ItemAmount: Number(this.info.payAmount) / 100,
                      ItemUnit: "元",
                    },
                  ],
                  SerialNumber: new Date().getTime(),
                  BizCode: this.info.orderNO,
                };
              } else {
                let recName = null;
                if (this.$store.state.streetorcommunityid == 410922000000) {
                  recName = "清丰县财政局国库股";
                } else if (this.$store.state.streetorcommunityid == 410926000000) {
                  recName = "范县财政局";
                } else if (this.$store.state.streetorcommunityid == 410928000000) {
                  recName = "濮阳县财政局";
                } else {
                  recName = "濮阳市财政局国库科";
                }
                data = {
                  soureType: "web",
                  payOrderNO: this.info.payOrderNo,
                  recName: recName,
                  orderNo: this.info.orderNO,
                  estateUnitNO: this.info.estateUnitNO,
                  totalAmount: Number(this.info.payAmount) / 100,
                  serialNumber: new Date().getTime(),
                  payerPartyName: payerPartyName,
                  payerPartyCode: payerPartyCode,
                  phone: phone,
                  auxItemRelatedName: auxItemRelatedName,
                  auxItemRelatedCode: auxItemRelatedCode,
                  theType: 3,
                  payerPartyType: payerPartyType,
                  handlingPerson: "线上",
                  checker: "线上",
                  items: [
                    {
                      itemName: itemName,
                      itemStd: itemStd,
                      itemQuantity: itemQuantity,
                      itemAmount: Number(this.info.payAmount) / 100,
                      itemCode: itemCode,
                      itemUnit: "元",
                    },
                  ],
                };
                console.log("在这", data);
              }
            }
          }
        } else if (this.info.orderTypeName == "新房办证期转现") {
          let payerPartyName = "";
          let payerPartyCode = "";
          let phone = "";
          let payerPartyType = 2;
          let newres = await this.$get(getuser3list, {
            orderNO: this.info.orderNO,
          });
          console.log(newres);
          if (newres.isSucceed) {
            if (newres.rows && newres.rows.length > 0) {
              let userlist = newres.rows[0];
              if (userlist && userlist.length > 0) {
                for (let i = 0; i < userlist.length; i++) {
                  if (userlist[i].userType == 3) {
                    payerPartyName = userlist[i].bankName;
                    payerPartyCode = userlist[i].registrationNno;
                    phone = userlist[i].phoneNO;
                    break;
                  }
                }
              }
              if (this.$store.state.streetorcommunityid == 410927000000) {
                data = {
                  soureType: "web",
                  estateUnitNO: this.info.estateUnitNO,
                  reason: "",
                  orderNo: this.info.orderNO,
                  payOrderNO: this.info.payOrderNo,
                  PayerPartyName: payerPartyName,
                  PlaceCode: "",
                  TotalAmount: Number(this.info.payAmount) / 100,
                  PayerPartyCode: payerPartyCode,
                  Remark: "",
                  PayerPartyType: payerPartyType,
                  Details: [
                    {
                      ItemCode: itemCode,
                      ItemRemark: "",
                      ItemQuantity: itemQuantity,
                      ItemName: itemName,
                      ItemStd: itemStd,
                      ItemAmount: Number(this.info.payAmount) / 100,
                      ItemUnit: "元",
                    },
                  ],
                  SerialNumber: new Date().getTime(),
                  BizCode: this.info.orderNO,
                };
              } else {
                let recName = null;
                if (this.$store.state.streetorcommunityid == 410922000000) {
                  recName = "清丰县财政局国库股";
                } else if (this.$store.state.streetorcommunityid == 410926000000) {
                  recName = "范县财政局";
                } else if (this.$store.state.streetorcommunityid == 410928000000) {
                  recName = "濮阳县财政局";
                } else {
                  recName = "濮阳市财政局国库科";
                }
                data = {
                  soureType: "web",
                  payOrderNO: this.info.payOrderNo,
                  recName: recName,
                  orderNo: this.info.orderNO,
                  estateUnitNO: this.info.estateUnitNO,
                  totalAmount: Number(this.info.payAmount) / 100,
                  serialNumber: new Date().getTime(),
                  payerPartyName: payerPartyName,
                  payerPartyCode: payerPartyCode,
                  phone: phone,
                  auxItemRelatedName: auxItemRelatedName,
                  auxItemRelatedCode: auxItemRelatedCode,
                  theType: 3,
                  payerPartyType: payerPartyType,
                  handlingPerson: "线上",
                  checker: "线上",
                  items: [
                    {
                      itemName: itemName,
                      itemStd: itemStd,
                      itemQuantity: itemQuantity,
                      itemAmount: Number(this.info.payAmount) / 100,
                      itemCode: itemCode,
                      itemUnit: "元",
                    },
                  ],
                };
              }
            }
          }
        } else if (this.info.orderTypeName == "现房抵押") {
          if (!this.info.bankName) {
            let payerPartyName = "";
            let payerPartyCode = "";
            let phone = "";
            let payerPartyType = 1;
            let newres = await this.$get(getuser3list, {
              orderNO: this.info.orderNO,
            });
            console.log(newres);
            if (newres.isSucceed) {
              if (newres.rows && newres.rows.length > 0) {
                let userlist = newres.rows[0];
                if (userlist && userlist.length > 0) {
                  for (let i = 0; i < userlist.length; i++) {
                    if (userlist[i].userType == 1) {
                      payerPartyName = userlist[i].userName;
                      payerPartyCode = userlist[i].idCardNO;
                      phone = userlist[i].phoneNO;
                      break;
                    }
                  }
                }
                console.log(this.$store.state.streetorcommunityid);
                if (this.$store.state.streetorcommunityid == 410927000000) {
                  data = {
                    soureType: "web",
                    estateUnitNO: this.info.estateUnitNO,
                    reason: "",
                    orderNo: this.info.orderNO,
                    payOrderNO: this.info.payOrderNo,
                    PayerPartyName: payerPartyName,
                    PlaceCode: "",
                    TotalAmount: Number(this.info.payAmount) / 100,
                    PayerPartyCode: payerPartyCode,
                    Remark: "",
                    PayerPartyType: payerPartyType,
                    Details: [
                      {
                        ItemCode: itemCode,
                        ItemRemark: "",
                        ItemQuantity: itemQuantity,
                        ItemName: itemName,
                        ItemStd: itemStd,
                        ItemAmount: Number(this.info.payAmount) / 100,
                        ItemUnit: "元",
                      },
                    ],
                    SerialNumber: new Date().getTime(),
                    BizCode: this.info.orderNO,
                  };
                } else {
                  let recName = null;
                  if (this.$store.state.streetorcommunityid == 410922000000) {
                    recName = "清丰县财政局国库股";
                  } else if (this.$store.state.streetorcommunityid == 410926000000) {
                    recName = "范县财政局";
                  } else if (this.$store.state.streetorcommunityid == 410928000000) {
                    recName = "濮阳县财政局";
                  } else {
                    recName = "濮阳市财政局国库科";
                  }
                  data = {
                    soureType: "web",
                    payOrderNO: this.info.payOrderNo,
                    recName: recName,
                    orderNo: this.info.orderNO,
                    estateUnitNO: this.info.estateUnitNO,
                    totalAmount: Number(this.info.payAmount) / 100,
                    serialNumber: new Date().getTime(),
                    payerPartyName: payerPartyName,
                    payerPartyCode: payerPartyCode,
                    phone: phone,
                    auxItemRelatedName: auxItemRelatedName,
                    auxItemRelatedCode: auxItemRelatedCode,
                    theType: 3,
                    payerPartyType: payerPartyType,
                    handlingPerson: "线上",
                    checker: "线上",
                    items: [
                      {
                        itemName: itemName,
                        itemStd: itemStd,
                        itemQuantity: itemQuantity,
                        itemAmount: Number(this.info.payAmount) / 100,
                        itemCode: itemCode,
                        itemUnit: "元",
                      },
                    ],
                  };
                }
              }
            }
          } else {
            let payerPartyName = "";
            let payerPartyCode = "";
            let phone = "";
            let payerPartyType = 2;
            let newres = await this.$get(getuser3list, {
              orderNO: this.info.orderNO,
            });
            console.log(newres);
            if (newres.isSucceed) {
              if (newres.rows && newres.rows.length > 0) {
                let userlist = newres.rows[0];
                if (userlist && userlist.length > 0) {
                  for (let i = 0; i < userlist.length; i++) {
                    if (userlist[i].userType == 3) {
                      payerPartyName = userlist[i].bankName;
                      payerPartyCode = userlist[i].registrationNno;
                      phone = userlist[i].phoneNO;
                      break;
                    }
                  }
                }
                console.log(this.$store.state.streetorcommunityid);
                if (this.$store.state.streetorcommunityid == 410927000000) {
                  data = {
                    soureType: "web",
                    estateUnitNO: this.info.estateUnitNO,
                    reason: "",
                    orderNo: this.info.orderNO,
                    payOrderNO: this.info.payOrderNo,
                    PayerPartyName: payerPartyName,
                    PlaceCode: "",
                    TotalAmount: Number(this.info.payAmount) / 100,
                    PayerPartyCode: payerPartyCode,
                    Remark: "",
                    PayerPartyType: payerPartyType,
                    Details: [
                      {
                        ItemCode: itemCode,
                        ItemRemark: "",
                        ItemQuantity: itemQuantity,
                        ItemName: itemName,
                        ItemStd: itemStd,
                        ItemAmount: Number(this.info.payAmount) / 100,
                        ItemUnit: "元",
                      },
                    ],
                    SerialNumber: new Date().getTime(),
                    BizCode: this.info.orderNO,
                  };
                } else {
                  let recName = null;
                  if (this.$store.state.streetorcommunityid == 410922000000) {
                    recName = "清丰县财政局国库股";
                  } else if (this.$store.state.streetorcommunityid == 410926000000) {
                    recName = "范县财政局";
                  } else if (this.$store.state.streetorcommunityid == 410928000000) {
                    recName = "濮阳县财政局";
                  } else {
                    recName = "濮阳市财政局国库科";
                  }
                  data = {
                    soureType: "web",
                    payOrderNO: this.info.payOrderNo,
                    recName: recName,
                    orderNo: this.info.orderNO,
                    estateUnitNO: this.info.estateUnitNO,
                    totalAmount: Number(this.info.payAmount) / 100,
                    serialNumber: new Date().getTime(),
                    payerPartyName: payerPartyName,
                    payerPartyCode: payerPartyCode,
                    phone: phone,
                    auxItemRelatedName: auxItemRelatedName,
                    auxItemRelatedCode: auxItemRelatedCode,
                    theType: 3,
                    payerPartyType: payerPartyType,
                    handlingPerson: "线上",
                    checker: "线上",
                    items: [
                      {
                        itemName: itemName,
                        itemStd: itemStd,
                        itemQuantity: itemQuantity,
                        itemAmount: Number(this.info.payAmount) / 100,
                        itemCode: itemCode,
                        itemUnit: "元",
                      },
                    ],
                  };
                }
              }
            }
          }
        } else if (this.info.orderTypeName == "房屋拆分") {
          let payerPartyName = this.info.userName;
          let payerPartyCode = this.info.idCardNO;
          let phone = this.info.phoneNO;
          let payerPartyType = 1;
          if (this.$store.state.streetorcommunityid == 410927000000) {
            data = {
              soureType: "web",
              estateUnitNO: this.info.estateUnitNO,
              reason: "",
              orderNo: this.info.orderNO,
              payOrderNO: this.info.payOrderNo,
              PayerPartyName: payerPartyName,
              PlaceCode: "",
              TotalAmount: Number(this.info.payAmount) / 100,
              PayerPartyCode: payerPartyCode,
              Remark: "",
              PayerPartyType: payerPartyType,
              Details: [
                {
                  ItemCode: itemCode,
                  ItemRemark: "",
                  ItemQuantity: itemQuantity,
                  ItemName: itemName,
                  ItemStd: itemStd,
                  ItemAmount: Number(this.info.payAmount) / 100,
                  ItemUnit: "元",
                },
              ],
              SerialNumber: new Date().getTime(),
              BizCode: this.info.orderNO,
            };
          } else {
            let recName = null;
            if (this.$store.state.streetorcommunityid == 410922000000) {
              recName = "清丰县财政局国库股";
            } else if (this.$store.state.streetorcommunityid == 410926000000) {
              recName = "范县财政局";
            } else if (this.$store.state.streetorcommunityid == 410928000000) {
              recName = "濮阳县财政局";
            } else {
              recName = "濮阳市财政局国库科";
            }
            data = {
              soureType: "web",
              payOrderNO: this.info.payOrderNo,
              recName: recName,
              orderNo: this.info.orderNO,
              estateUnitNO: this.info.estateUnitNO,
              totalAmount: Number(this.info.payAmount) / 100,
              serialNumber: new Date().getTime(),
              payerPartyName: payerPartyName,
              payerPartyCode: payerPartyCode,
              phone: phone,
              auxItemRelatedName: auxItemRelatedName,
              auxItemRelatedCode: auxItemRelatedCode,
              theType: 3,
              payerPartyType: payerPartyType,
              handlingPerson: "线上",
              checker: "线上",
              items: [
                {
                  itemName: itemName,
                  itemStd: itemStd,
                  itemQuantity: itemQuantity,
                  itemAmount: Number(this.info.payAmount) / 100,
                  itemCode: itemCode,
                  itemUnit: "元",
                },
              ],
            };
          }
        } else if (this.info.orderTypeName == "换证") {
          let payerPartyName = this.info.userName;
          let payerPartyCode = this.info.idCardNO;
          let phone = this.info.phoneNO;
          let payerPartyType = 1;
          if (this.$store.state.streetorcommunityid == 410927000000) {
            data = {
              soureType: "web",
              estateUnitNO: this.info.estateUnitNO,
              reason: "",
              orderNo: this.info.orderNO,
              payOrderNO: this.info.payOrderNo,
              PayerPartyName: payerPartyName,
              PlaceCode: "",
              TotalAmount: Number(this.info.payAmount) / 100,
              PayerPartyCode: payerPartyCode,
              Remark: "",
              PayerPartyType: payerPartyType,
              Details: [
                {
                  ItemCode: itemCode,
                  ItemRemark: "",
                  ItemQuantity: itemQuantity,
                  ItemName: itemName,
                  ItemStd: itemStd,
                  ItemAmount: Number(this.info.payAmount) / 100,
                  ItemUnit: "元",
                },
              ],
              SerialNumber: new Date().getTime(),
              BizCode: this.info.orderNO,
            };
          } else {
            let recName = null;
            if (this.$store.state.streetorcommunityid == 410922000000) {
              recName = "清丰县财政局国库股";
            } else if (this.$store.state.streetorcommunityid == 410926000000) {
              recName = "范县财政局";
            } else if (this.$store.state.streetorcommunityid == 410928000000) {
              recName = "濮阳县财政局";
            } else {
              recName = "濮阳市财政局国库科";
            }
            data = {
              soureType: "web",
              payOrderNO: this.info.payOrderNo,
              recName: recName,
              orderNo: this.info.orderNO,
              estateUnitNO: this.info.estateUnitNO,
              totalAmount: Number(this.info.payAmount) / 100,
              serialNumber: new Date().getTime(),
              payerPartyName: payerPartyName,
              payerPartyCode: payerPartyCode,
              phone: phone,
              auxItemRelatedName: auxItemRelatedName,
              auxItemRelatedCode: auxItemRelatedCode,
              theType: 3,
              payerPartyType: payerPartyType,
              handlingPerson: "线上",
              checker: "线上",
              items: [
                {
                  itemName: itemName,
                  itemStd: itemStd,
                  itemQuantity: itemQuantity,
                  itemAmount: Number(this.info.payAmount) / 100,
                  itemCode: itemCode,
                  itemUnit: "元",
                },
              ],
            };
          }
        } else if (this.info.orderTypeName == "一般变更") {
          let payerPartyName = this.info.userName;
          let payerPartyCode = this.info.idCardNO;
          let phone = this.info.phoneNO;
          let payerPartyType = 1;
          if (this.$store.state.streetorcommunityid == 410927000000) {
            data = {
              soureType: "web",
              estateUnitNO: this.info.estateUnitNO,
              reason: "",
              orderNo: this.info.orderNO,
              payOrderNO: this.info.payOrderNo,
              PayerPartyName: payerPartyName,
              PlaceCode: "",
              TotalAmount: Number(this.info.payAmount) / 100,
              PayerPartyCode: payerPartyCode,
              Remark: "",
              PayerPartyType: payerPartyType,
              Details: [
                {
                  ItemCode: itemCode,
                  ItemRemark: "",
                  ItemQuantity: itemQuantity,
                  ItemName: itemName,
                  ItemStd: itemStd,
                  ItemAmount: Number(this.info.payAmount) / 100,
                  ItemUnit: "元",
                },
              ],
              SerialNumber: new Date().getTime(),
              BizCode: this.info.orderNO,
            };
          } else {
            let recName = null;
            if (this.$store.state.streetorcommunityid == 410922000000) {
              recName = "清丰县财政局国库股";
            } else if (this.$store.state.streetorcommunityid == 410926000000) {
              recName = "范县财政局";
            } else if (this.$store.state.streetorcommunityid == 410928000000) {
              recName = "濮阳县财政局";
            } else {
              recName = "濮阳市财政局国库科";
            }
            data = {
              soureType: "web",
              payOrderNO: this.info.payOrderNo,
              recName: recName,
              orderNo: this.info.orderNO,
              estateUnitNO: this.info.estateUnitNO,
              totalAmount: Number(this.info.payAmount) / 100,
              serialNumber: new Date().getTime(),
              payerPartyName: payerPartyName,
              payerPartyCode: payerPartyCode,
              phone: phone,
              auxItemRelatedName: auxItemRelatedName,
              auxItemRelatedCode: auxItemRelatedCode,
              theType: 3,
              payerPartyType: payerPartyType,
              handlingPerson: "线上",
              checker: "线上",
              items: [
                {
                  itemName: itemName,
                  itemStd: itemStd,
                  itemQuantity: itemQuantity,
                  itemAmount: Number(this.info.payAmount) / 100,
                  itemCode: itemCode,
                  itemUnit: "元",
                },
              ],
            };
          }
        }
        if (
          this.$store.state.streetorcommunityid == 410927000000 &&
          data.SerialNumber
        ) {
          data.SerialNumber = this.info.orderNO;
        }
        console.log(data);
        let res = await this.$post(invoice, data);
        if (res.isSucceed) {
          if (res.message) {
            this.$Message.success(res.message);
          } else {
            this.$Message.success("开票成功");
          }
          this.getTaxInfoList();
        } else {
          if (res.message) {
            this.$Message.success(res.message);
          } else {
            this.$Message.success("开票失败");
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    handleSelect(selection) {
      console.log(selection);
      this.selectedList = [];
      selection.forEach((item) => {
        this.selectedList.push(item.orderNO);
      });
      console.log(this.selectedList);
    },
    async showModalConfirm1() {
      this.isLoading = true;
      let data = {
        orderNOList: this.selectedList.join(","),
      };
      try {
        let res = await this.$post(updateInvoiceList, data);
        this.$Message.success("开票成功");
        this.selectedList = [];
        this.getTaxInfoList();
      } finally {
        this.isLoading = false;
      }
    },
    cancelModal() {},
    handleClickDetail1(item) {
      this.$router.push({
        name: "regfeeDetail",
        query: {
          orderNO: item.orderNO,
          estateUnitNO: item.estateUnitNO,
          orderType:
            item.orderTypeName == "新房办证期转现" ? 99 : item.orderType,
        },
      });
    },
    cancelgored() {
      this.modal3 = false;
      this.redreason = "";
    },
    async dogored() {
      console.log(this.formItems.redreason);
      if (!this.formItems.redreason) {
        this.$Message.error("请输入冲红原因");
      }
      try {
        let data = {
          eInvoiceCode: this.info.einvoiceCode,
          eInvoiceNumber: this.info.einvoiceNumber,
          reason: this.formItems.redreason,
          id: this.info.eticketid,
          soureType: "web",
        };
        let res = await this.$post(cancellation, data);
        if (res.isSucceed) {
          this.$Message.success(res.message);
          this.cancelgored();
          this.selectedList = [];
          this.getTaxInfoList();
        }
      } finally {
        this.isLoading = false;
      }
    },
    handleClickDetail(item, type) {
      
      if (type == "detail") {
        this.$router.push({
          name: "regfeeDetail",
          query: {
            orderNO: item.orderNO,
            estateUnitNO: item.estateUnitNO,
            orderType:
              item.orderTypeName == "新房办证期转现" ? 99 : item.orderType,
          },
        });
      } else if (type == "fee") {
        console.log("开票");
        this.info = item;
        this.showModal = true;
      } else if (type == "gored") {
        console.log("冲红");
        this.info = item;
        this.modal3 = true;
        this.redreason = "";
      } else if (type == "preview") {
        console.log("预览发票");
        this.info = item;
        if (item.innerPdfAddr) {
          window.open(item.innerPdfAddr);
        }

        // this.showPreview.list = [{ isHeight: true, path:item.innerPdfAddr}];
        // this.showPreview.show = 1;
      }
    },
    closePreview() {
      console.log("========closePreview==========");
      this.showPreview.list = [];
      this.showPreview.show = 0;
    },
    pageChange(val) {
      this.pageNum = val;
      this.getTaxInfoList();
    },
    async getTaxInfoList() {
      this.isLoading = true;
      try {
        if (this.time[0]) {
          this.query.createTime = this.$util.FormatDate(
            new Date(this.time[0]),
            "yyyy-MM-dd"
          );
          this.query.updateTime = this.$util.FormatDate(
            new Date(this.time[1]),
            "yyyy-MM-dd"
          );
        }
        if (!this.$store.state.streetorcommunityid == "410927000000") {
          delete this.query.remitState;
        }
        let res = await this.$post(taxInfoList, {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          communityId: this.$store.state.streetorcommunityid,
          ...this.query,
        });
        console.log("三生三世");
        console.log(this.$store.state.streetorcommunityid);

        let list = res.rows.map((item) => ({
          ...item,
          newpayAmount: this.$util.accDiv(item.payAmount, 100) + "元",
          updateTime: item.updateTime.substr(0, 19),
          ...INVOICEMAP[item.state != null ? +item.state : null],
          ...remitState[item.remitState != null ? +item.remitState : null],
          ...TYPEMAP[item.orderType != null ? +item.orderType : null],
        }));
        // console.log(list);
        this.tableData = list;
        this.total = res.total;
        this.invoiceAmount = res.newPrimaryKeys.openMoney;
        this.amount = res.newPrimaryKeys.noOpenMoney;
        this.totalAmount =
          (Number(res.newPrimaryKeys.allMoney).toFixed(2) * 100) / 100;
      } finally {
        this.isLoading = false;
      }
    },
  },

  created() {
    this.getTaxInfoList();
    if (this.$store.state.streetorcommunityid == 410927000000) {
      this.tableHeader = [
        {
          type: "selection",
          width: 70,
          align: "center",
        },
        {
          title: "序号",
          type: "index",
          width: 60,
          align: "center",
        },
        {
          title: "不动产业务类型",
          key: "orderTypeName",
          width: 140,
        },
        {
          title: "不动产业务单号",
          key: "orderNO",
          width: 140,
        },
        {
          title: "不动产单元号",
          key: "estateUnitNO",
          width: 100,
        },
        {
          title: "银行名称",
          key: "bankName",
          width: 100,
        },
        {
          title: "银行经理/权利人",
          key: "userName",
          width: 100,
        },
        {
          title: "义务人",
          key: "obligor",
          width: 80,
        },
        {
          title: "登记费缴纳订单号",
          key: "payOrderNo",
          width: 100,
        },
        {
          title: "支付时间",
          key: "updateTime",
          width: 180,
        },
        {
          title: "缴纳金额",
          key: "newpayAmount",
          width: 100,
        },
        {
          title: "是否开票",
          key: "state",
          width: 100,
        },
        {
          title: "是否汇缴",
          key: "remitState",
          width: 100,
        },
        {
          title: "电子票号",
          key: "einvoiceNumber",
          width: 100,
        },
        {
          title: "操作",
          slot: "action",
          width: 140,
        },
      ];
    }
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.content {
  margin: 20px;
}

.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.label {
  width: 100px;
}

.time {
  width: 100%;
}

.table-data {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  min-height: calc(100vh - 450px);

  .page {
    width: 100%;
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }

  .success {
    color: #ff7b44;
  }

  .action {
    color: #5e6d94;
    cursor: pointer;
    margin-right: 10px;
  }
}

.statistics {
  padding: 10px 0;
  text-align: right;
}
</style>
